module.exports = __webpack_public_path__ + "static/media/organization.bbf2a2fd.png";